import {inject, Injectable} from '@angular/core';
import {ToastService} from '@ratespecial/core';

/**
 * True when value is an object carrying the key as its own property.
 */
const has = (value: unknown, key: string): boolean => typeof value === 'object' && value !== null && Object.hasOwn(value, key);

@Injectable({
  providedIn: 'root',
})
export class HttpErrorService {
  private notificationService = inject(ToastService);


  /**
   * Handle any http error that comes back from Server side
   * @param err
   */
  handleError(err): void {
    if (has(err.error, 'errors')) {
      // Assume we have an array
      this.handleErrorArray(err);

    } else if (typeof err.error === 'object') {
      this.handleErrorObject(err.error);

    } else {
      // Assuming error is just a string
      this.notificationService.error(err.error);
    }
  }


  /**
   * Handle an error that is an object
   * @param error
   */
  handleErrorObject(error): void {
    if (this.isApiError(error)) {
      this.notificationService.error('<strong>' + error.code + ' ' + error.title + '</strong>: ' + error.detail);
    } else if (has(error, 'error')) {
      this.notificationService.error(error.error);
    }
    // This is what laravel comes through as with a super generic exception
    else if (has(error, 'message')) {
      this.notificationService.error(error.message);

    } else if (has(error, 'msg')) {
      this.notificationService.error(error.msg);
    }
  }

  /**
   * Handle array of errors
   * @param err
   */
  handleErrorArray(err) {
    err.error.errors.map(error => {
      // Are the errors an array of API Error Objects or an array of strings
      if (typeof error === 'string') {
        this.notificationService.error(error);
      } else {
        this.notificationService.error('<strong>' + error.code + ' ' + error.title + '</strong>: ' + error.detail);
      }
    });
  }

  /**
   * Returns true if error is our internal Api Error Object
   * @param error
   * @returns {boolean}
   */
  isApiError(error) {
    return has(error, 'code') && has(error, 'detail');
  }
}
